import { ref } from 'vue';

/**
 * Site-wide chat dock state. Any component (navbar, teach page, footer…)
 * can open the dock — optionally seeding a prompt that JB answers as soon
 * as the panel opens.
 */
export const dockOpen = ref(false);
export const dockSeed = ref(null);

/** Set when a response lands while the panel is closed → launcher badge. */
export const dockUnread = ref(false);

export function openDock(seedPrompt = null) {
  dockSeed.value = seedPrompt ? String(seedPrompt) : null;
  dockOpen.value = true;
  dockUnread.value = false;
}

export function closeDock() {
  dockOpen.value = false;
}

export function toggleDock() {
  if (dockOpen.value) closeDock();
  else openDock();
}

/** Consume a pending seed (called by the dock after sending). */
export function takeSeed() {
  const seed = dockSeed.value;
  dockSeed.value = null;
  return seed;
}
